export default {"src":"/_next/static/media/0xdfc14d2af169b0d36c4eff567ada9b2e0cae044f.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};